module.exports = __webpack_public_path__ + "static/media/silvio.46871f87.jpeg";